import { connect } from 'react-redux';
import { MainNavigation } from './MainNavigation';

const Enhanced = connect((state) => ({ globalSettings: state.admin.globalSettings }))(MainNavigation);

export { Enhanced as MainNavigation }
